import { render, staticRenderFns } from "./AppCpfField.vue?vue&type=template&id=009a635f&"
import script from "./AppCpfField.vue?vue&type=script&lang=js&"
export * from "./AppCpfField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports